import React from "react";
import "./Banner.css"; // Make sure this path matches your project structure

const Banner = ({ announcements }) => {
  if (!announcements || announcements.length === 0) return null;

  const getIcon = (type) => {
    switch (type) {
      case "error":
        return "⛔";
      case "warning":
        return "⚠️";
      case "information":
      default:
        return "ℹ️";
    }
  };

  return (
    <div className="banner-container">
      {announcements.map((announcement, index) => (
        <div key={index} className={`banner banner-${announcement.type}`}>
          <span className="banner-icon">{getIcon(announcement.type)}</span>
          <span className="banner-text">{announcement.message}</span>
        </div>
      ))}
    </div>
  );
};

export default Banner;
